





(function initNavMarquee() {
const track = document.getElementById('marqueeTrack');
const btnLeft = document.getElementById('marqueeArrowLeft');
const btnRight = document.getElementById('marqueeArrowRight');
if (!track || !btnLeft || !btnRight) return;

const VISIBLE = 4;
const realCards = Array.from(track.children);
const total = realCards.length;
const originalFirst = track.firstChild;

realCards.slice(-VISIBLE).forEach(c => track.insertBefore(c.cloneNode(true), originalFirst));

realCards.slice(0, VISIBLE).forEach(c => track.appendChild(c.cloneNode(true)));

let index = VISIBLE;
let animating = false;

function step() {
const card = track.children[0];
if (!card) return 0;
const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
return card.getBoundingClientRect().width + gap;
}

function apply(withTransition) {
if (!withTransition) {
track.style.transition = 'none';
track.style.transform = 'translateX(-' + (index * step()) + 'px)';
void track.offsetWidth;
track.style.transition = '';
} else {
track.style.transform = 'translateX(-' + (index * step()) + 'px)';
}
}

function go(delta) {
if (animating) return;
animating = true;
index += delta;
apply(true);
}

track.addEventListener('transitionend', (e) => {
if (e.propertyName !== 'transform') return;
animating = false;
if (index <= 0) { index += total; apply(false); }
else if (index >= VISIBLE + total) { index -= total; apply(false); }
});

btnRight.addEventListener('click', () => go(1));
btnLeft.addEventListener('click', () => go(-1));
window.addEventListener('resize', () => apply(false));

apply(false);
})();






(function initNavMarqueeToggle() {
const wrap = document.querySelector('.nav-fournisseurs-wrap');
const panel = document.querySelector('.nav-marquee-panel');
const navEl = document.querySelector('nav');
if (!wrap || !panel || !navEl) return;

let closeTimer = null;

function open() {
clearTimeout(closeTimer);
const wasOpen = wrap.classList.contains('is-open');
wrap.classList.add('is-open');
}
function scheduleClose() {
clearTimeout(closeTimer);
closeTimer = setTimeout(() => wrap.classList.remove('is-open'), 150);
}
function keepOpenIfAlreadyOpen() {
if (wrap.classList.contains('is-open')) clearTimeout(closeTimer);
}

wrap.addEventListener('mouseenter', open);
panel.addEventListener('mouseenter', open);
navEl.addEventListener('mouseenter', keepOpenIfAlreadyOpen);
navEl.addEventListener('mouseleave', scheduleClose);
panel.addEventListener('mouseleave', scheduleClose);

panel.addEventListener('click', (e) => {
const card = e.target.closest && e.target.closest('.nav-mcard');
if (!card) return;
const pack = (card.getAttribute('href') || '').split('/').pop();

});
})();

(function initNavDrawer() {
const burger = document.getElementById('navBurgerBtn');
const drawer = document.getElementById('navDrawer');
const backdrop = document.getElementById('navDrawerBackdrop');
if (!burger || !drawer || !backdrop) return;

function open() {
burger.classList.add('is-open');
burger.setAttribute('aria-expanded', 'true');
drawer.classList.add('is-open');
backdrop.classList.add('is-open');
}
function close() {
burger.classList.remove('is-open');
burger.setAttribute('aria-expanded', 'false');
drawer.classList.remove('is-open');
backdrop.classList.remove('is-open');
}

burger.addEventListener('click', () => {
drawer.classList.contains('is-open') ? close() : open();
});
backdrop.addEventListener('click', close);

drawer.querySelectorAll('.nav-drawer-link').forEach(a => a.addEventListener('click', close));
})();

(function initHeroReveal() {
if (!document.getElementById('hrDT')) return;
const P = document.documentElement.dataset.heroBase;

const ROW_TOP = [
{ img:P+'accessoires-bonnet-lv-xs.webp',           n:'Mütze L** V**',      c:'Accessoires' },
{ img:P+'accessoires-casquette-chrome-xs.webp',    n:'Cap Chr*me',    c:'Accessoires' },
{ img:P+'accessoires-portefeuille-goyard-xs.webp', n:'Portemonnaie G*yard', c:'Accessoires' },
{ img:P+'lego-gt3rs-xs.webp',                      n:'Technic GT3RS',       c:'Bausteine' },
{ img:P+'parfums-baccarat-540-xs.webp',            n:'Bacc*rat 540',        c:'Parfums' },
{ img:P+'parfums-sauvage-xs.webp',                 n:'Sauv*ge',             c:'Parfums' },
{ img:P+'sacs-sac-lv-xs.webp',                     n:'Tasche L** V**',         c:'Taschen' },
{ img:P+'sneakers-b30-xs.webp',                    n:'Di*r B30',            c:'Sneakers' },
{ img:P+'sneakers-onclouds-xs.webp',               n:'OnCl*uds',            c:'Sneakers' },
{ img:P+'volants-amg-xs.webp',                     n:'Lenkrad Custom AMG',   c:'Lenkräder' },
{ img:P+'volants-brabus-xs.webp',                  n:'Lenkrad BRAB*S',       c:'Lenkräder' },
{ img:P+'lego-air-xs.webp',                        n:'L*GO Air',            c:'Bausteine' },
];
const ROW_MID = [
{ img:P+'accessoires-bracelet-lv-xs.webp',      n:'Armband L** V**', c:'Accessoires' },
{ img:P+'accessoires-echarpe-burberry-xs.webp', n:'Schal B*rberry', c:'Accessoires' },
{ img:P+'parfums-ambre-nomade-xs.webp',         n:'Ombre N*made',     c:'Parfums' },
{ img:P+'parfums-bleu-de-chanel-xs.webp',       n:'Bl*u de Ch*nel',   c:'Parfums' },
{ img:P+'sacs-celine-triomphe-xs.webp',         n:'C*line Triomphe',  c:'Taschen' },
{ img:P+'sacs-sacoche-goyard-xs.webp',          n:'Umhängetasche G*yard',   c:'Taschen' },
{ img:P+'sneakers-chanel-runners-xs.webp',      n:'Ch*nel Runners',   c:'Sneakers' },
{ img:P+'sneakers-prada-cup-xs.webp',           n:'Pr*da Cup',        c:'Sneakers' },
{ img:P+'volants-m-xs.webp',                    n:'Lenkrad Custom M',  c:'Lenkräder' },
{ img:P+'volants-rs-xs.webp',                   n:'Lenkrad Custom RS', c:'Lenkräder' },
{ img:P+'lego-cdm-xs.webp',                     n:'L*GO CDM',         c:'Bausteine' },
];
const ROW_BOT = [
{ img:P+'accessoires-cartier-clou-xs.webp',     n:'C*rtier Clou',     c:'Accessoires' },
{ img:P+'accessoires-lunettes-versace-xs.webp', n:'Brille V*rsace', c:'Accessoires' },
{ img:P+'lego-chiron-xs.webp',                  n:'Technic Ch*ron',   c:'Bausteine' },
{ img:P+'parfums-aventus-xs.webp',              n:'Avent*s',          c:'Parfums' },
{ img:P+'parfums-eros-xs.webp',                 n:'Er*s',             c:'Parfums' },
{ img:P+'sacs-lady-dior-xs.webp',               n:'Lady Di*r',        c:'Taschen' },
{ img:P+'sacs-timeless-chanel-xs.webp',         n:'Timeless Ch*nel',  c:'Taschen' },
{ img:P+'sneakers-kayano-14-xs.webp',           n:'K*yano 14',        c:'Sneakers' },
{ img:P+'volants-vw-xs.webp',                   n:'Lenkrad Custom VW', c:'Lenkräder' },
{ img:P+'volants-porsche-xs.webp',              n:'Lenkrad P*rsche',   c:'Lenkräder' },
{ img:P+'lego-starwars-xs.webp',                n:'L*GO Star W*rs',   c:'Bausteine' },
];
const realCard = d => `<div class="hr-card"><img class="hr-thumb" src="${d.img}?v=9" alt="" loading="eager" fetchpriority="low" decoding="async" /><div class="hr-info"><span class="hr-name">${d.n}</span><div class="hr-margin-row"><span class="hr-margin-label">${document.documentElement.dataset.heroCategory || ""}</span><span class="hr-margin-badge">${d.c}</span></div></div></div>`;
const skelCard = (nw, lw, bw) => `<div class="hr-card hr-skel"><div class="hr-thumb-sk"></div><div class="hr-info"><span class="hr-bar hr-bar-name" style="width:${nw}px"></span><div class="hr-margin-row"><span class="hr-bar hr-bar-label" style="width:${lw}px"></span><span class="hr-bar hr-bar-badge" style="width:${bw}px"></span></div></div></div>`;






const fill = (id, html) => { const el = document.getElementById(id); if (el) el.innerHTML = html + html; };
const buildRow = (dataId, skelId, rows) => {
fill(dataId, rows.map(realCard).join(''));
const cards = document.getElementById(dataId).querySelectorAll('.hr-card');
let skelHtml = '';
for (let i = 0; i < rows.length; i++) {
const nw = cards[i].querySelector('.hr-name').offsetWidth;
const lw = cards[i].querySelector('.hr-margin-label').offsetWidth;
const bw = cards[i].querySelector('.hr-margin-badge').offsetWidth;
skelHtml += skelCard(nw, lw, bw);
}
fill(skelId, skelHtml);
};















var LOGO_DELAY = 500;
var STACK_STAGGER = 500;
var logoImg = document.querySelector('.hr-logo img');
var hrStackEl = document.querySelector('.hr-stack');
var imgReadyTime = null;
var rowsReady = false;








var heroReadsSuspendedUntil = 0;
window.__pauseHeroRevealReads = function (ms) {
heroReadsSuspendedUntil = performance.now() + ms;
};
function scheduleStackReveal() {
if (!rowsReady || imgReadyTime === null || !hrStackEl) return;
var wait = Math.max(0, (imgReadyTime + LOGO_DELAY + STACK_STAGGER) - performance.now());
setTimeout(function () { hrStackEl.classList.add('hr-in'); }, wait);
}
function onImageReady() {
imgReadyTime = performance.now();
setTimeout(function () { if (logoImg) logoImg.classList.add('hr-in'); }, LOGO_DELAY);
scheduleStackReveal();
}
if (logoImg) {
if (logoImg.complete && logoImg.naturalWidth > 0) onImageReady();
else {
logoImg.addEventListener('load', onImageReady, { once: true });
logoImg.addEventListener('error', onImageReady, { once: true });
}
} else {
imgReadyTime = performance.now();
}








function start() {
buildRow('hrDT', 'hrSkT', ROW_TOP);
buildRow('hrDM', 'hrSkM', ROW_MID);
buildRow('hrDB', 'hrSkB', ROW_BOT);



rowsReady = true;
scheduleStackReveal();














var DURATION_DESKTOP = 55, DURATION_MOBILE = 81;
var ROT_EDGE_DESKTOP = 10.5;
var ROT_EDGE_MOBILE = 6;
var DEG = Math.PI / 180;
var scrollStart = performance.now();
var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

var ROWS = [
{ sel: 'top', skel: document.getElementById('hrSkT'), data: document.getElementById('hrDT'), stagger: 0, k: 1 },
{ sel: 'mid', skel: document.getElementById('hrSkM'), data: document.getElementById('hrDM'), stagger: 3, k: 0 },
{ sel: 'bot', skel: document.getElementById('hrSkB'), data: document.getElementById('hrDB'), stagger: 6, k: -1 }
].map(function (rc) {
rc.rowEl = document.querySelector('.hero-reveal .hr-row-' + rc.sel);
rc.width = rc.data.scrollWidth / 2;



rc.cards = [];
if (rc.k !== 0) {
[rc.skel, rc.data].forEach(function (track) {
[].slice.call(track.querySelectorAll('.hr-card')).forEach(function (el) {
rc.cards.push({ el: el, left: el.offsetLeft, width: el.offsetWidth });
});
});
}
return rc;
});

function frame() {
var now = performance.now();
var half = window.innerWidth / 2;
var edge = window.innerWidth <= 768 ? ROT_EDGE_MOBILE : ROT_EDGE_DESKTOP;
var duration = window.innerWidth <= 768 ? DURATION_MOBILE : DURATION_DESKTOP;
var R = half / Math.sin(edge * DEG);
var i, j;




var rowLefts = [];
var canReadLayout = now >= heroReadsSuspendedUntil;
for (i = 0; i < ROWS.length; i++) {
var row = ROWS[i];
if (row.k === 0) { rowLefts[i] = 0; continue; }
if (canReadLayout) row.lastLeft = row.rowEl.getBoundingClientRect().left;
rowLefts[i] = row.lastLeft || 0;
}



for (i = 0; i < ROWS.length; i++) {
var rc = ROWS[i];
var elapsed = (now - scrollStart) / 1000 + rc.stagger;
var speed = rc.width / duration;
var offset = (elapsed * speed) % rc.width;


var tx = offset - rc.width;
var txStr = 'translate3d(' + tx + 'px,0,0)';
rc.skel.style.transform = txStr;
rc.data.style.transform = txStr;
if (rc.k === 0) continue;
var rowLeft = rowLefts[i];
for (j = 0; j < rc.cards.length; j++) {
var c = rc.cards[j];
var centerX = rowLeft + tx + c.left + c.width / 2;
var d = centerX - half, s = d / R; if (s > 1) s = 1; else if (s < -1) s = -1;
var th = Math.asin(s);
var rot = -(th / DEG) * rc.k;
var ty = -R * (1 - Math.cos(th)) * rc.k;
rot = Math.max(-11, Math.min(11, rot));
ty = Math.max(-70, Math.min(70, ty));
c.el.style.transform = 'translate3d(0,' + ty + 'px,0) rotate(' + rot + 'deg)';
}
}
requestAnimationFrame(frame);
}
if (!reduceMotion) requestAnimationFrame(frame);
}

if (document.fonts && document.fonts.ready) {
document.fonts.ready.then(start);
} else {
start();
}
})();

document.querySelectorAll("[data-cart-open]").forEach(el=>el.addEventListener("click",()=>location.href=document.documentElement.dataset.cartUrl));
const toggle=document.getElementById('packs-toggle-btn');
const extra=document.getElementById('packs-grid-extra');
if(toggle&&extra){
extra.inert=true;
toggle.addEventListener('click',()=>{
const open=extra.classList.toggle('is-visible');
extra.inert=!open;
extra.style.maxHeight=open?extra.scrollHeight+'px':'0px';
toggle.classList.toggle('is-open',open);
toggle.setAttribute('aria-expanded',String(open));
toggle.querySelector('.label').textContent=open?toggle.dataset.less:toggle.dataset.more;
});
window.addEventListener('resize',()=>{if(extra.classList.contains('is-visible'))extra.style.maxHeight=extra.scrollHeight+'px';});
}
document.addEventListener('click',event=>{
const link=event.target.closest('a[href]');
if(!link)return;
const url=new URL(link.href,location.href);
if(url.origin!==location.origin||!url.hash)return;
const target=document.getElementById(decodeURIComponent(url.hash.slice(1)));
if(!target)return;
event.preventDefault();
target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
history.replaceState(null,'',location.pathname+location.search+url.hash);
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'&&document.getElementById('navBurgerBtn')?.getAttribute('aria-expanded')==='true')document.getElementById('navBurgerBtn').click();});

(()=>{const body=document.getElementById('aiChatBody');document.querySelectorAll('.ai-q-btn').forEach(button=>button.addEventListener('click',()=>{if(!body)return;document.querySelectorAll('.ai-q-btn').forEach(b=>b.classList.remove('is-asked'));button.classList.add('is-asked');for(const [cls,text] of [['ai-msg-user',button.textContent],['ai-msg-bot',button.dataset.answer]]){const bubble=document.createElement('div');bubble.className='ai-msg '+cls;bubble.textContent=text;body.append(bubble)}body.scrollTop=body.scrollHeight}));})();

(()=>{const duo=document.querySelector('[data-duo]');if(!duo)return;const opts=[...duo.querySelectorAll('.pp-duo-option')],add=duo.querySelector('#DuoAdd');let selected;const money=n=>new Intl.NumberFormat('de-DE',{style:'currency',currency:duo.dataset.currency||'EUR'}).format(n/100);function choose(button){selected=button;opts.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));const d=button.dataset;document.getElementById('DuoPartnerImage').src=d.image;document.getElementById('DuoPartnerImage').removeAttribute('srcset');document.getElementById('DuoPartnerImage').alt=d.title;document.getElementById('DuoPartnerName').textContent=d.title;document.getElementById('DuoPartnerPrice').textContent=money(+d.price);const sum=+d.price + +duo.dataset.firstPrice;document.getElementById('DuoOld').textContent=money(sum);document.getElementById('DuoNew').textContent=money(Math.round(sum*.8));add.disabled=duo.dataset.firstAvailable!=='true'||d.available!=='true';add.textContent=add.disabled?duo.dataset.unavailable:duo.dataset.both}opts.forEach(b=>b.addEventListener('click',()=>choose(b)));const first=opts.find(b=>b.getAttribute('aria-pressed')==='true')||opts[0];if(first)choose(first);add.addEventListener('click',async()=>{if(!selected||add.disabled)return;add.disabled=true;add.textContent=duo.dataset.loading;const err=duo.querySelector('[role="status"]');err.textContent='';try{const base=window.Shopify?.routes?.root||'/';const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:duo.dataset.firstId,quantity:1},{id:selected.dataset.id,quantity:1}]})});if(!response.ok)throw new Error();location.href=document.documentElement.dataset.cartUrl}catch{err.textContent=duo.dataset.error;choose(selected)}})})();

// Show the mobile purchase bar once the main product form has scrolled above the viewport.
(() => {
  const bar = document.querySelector('.pp-sticky');
  const form = document.getElementById('FioProductForm');
  if (!bar || !form) return;
  const mobile = window.matchMedia('(max-width: 768px)');
  const update = () => {
    const show = mobile.matches && form.getBoundingClientRect().bottom <= 0;
    bar.classList.toggle('is-visible', show);
    bar.inert = !show;
    bar.setAttribute('aria-hidden', String(!show));
  };
  bar.inert = true;
  bar.setAttribute('aria-hidden', 'true');
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
